// TODO: make staging env api url key as same as dashboard dev env

import mapValues from "lodash/fp/mapValues";
const APIURL = process.env.API_URL || process.env.BUILD_API_URL;
export const baseUrl = APIURL;
const backslash = "/";
const endpoints = {
  auditor: "audit",
  backup: "backup",
  backupRecommendation: "backup_recommendations",
  backupSchedule: "backupschedule",
  bookings: "booking",
  bus: "bus",
  bulkbonuses: "bulk_bonus",
  bulkScripts: "bulk_action",
  basicPlan: "captain_finances/basic_plan",
  backupPlan: "captain_finances/backup_plan",
  variablePlan: "captain_finances/variable_plan",
  fulfillmentPlan: "captain_finances/fulfillment_plan",
  bustype: "bustype",
  captain: "captain",
  captainPlan: "captain_finances/captain_plan",
  city: "city",
  country: "country",
  company: "company",
  corporate: "corporate",
  credits: "creditupload",
  currency: "currency",
  deductionPlan: "captain_finances/deduction_plan",
  dispatcher: "dispatcher_report",
  district: "district",
  invoice: "captain_finances/captain_invoice",
  invoiceItem: "captain_finances/invoice_item",
  invoiceItemType: "captain_finances/invoice_item_type",
  invoiceItemFileTransaction: "captain_finances/invoice_item_file_transaction",
  holiday: "holiday",
  login: "sign_in",
  logout: "sign_out",
  notes: "note",
  paymentCycle: "captain_finances/payment_cycle",
  loan: "captain_finances/loan",
  tags: "tag",
  promotion: "promotion",
  rating: "rating",
  refreshToken: "token/refresh",
  report: "report",
  reservation: "corporateReservation",
  ride: "ride",
  dynamicRide: "dynamic_ride",
  analyseBackup: "backup_recommendations/events",
  route: "route",
  schedule: "schedule",
  station: "station",
  subscription: "subscription",
  ticket: "ticket",
  transactions: "transaction",
  topup: "topup",
  universal: "search/universal",
  user: "user",
  userpromotion: "userpromotion",
  rougena: "rougena",
  marketingEvents: "event",
  travelRequests: "request_travel",
  privateBusRequests: "private_bus_request",
  pricing: "private_bus_pricing",
  contracts: "corporate_contract",
  corporateInvoices: "corporate/invoices",
  corporateInvoiceItems: "corporate/invoice_items",
  corporateTransportationSubmissions: "corporate_transportation_request",
  contractor: "contractor",
  contractors: "contractors",
  packages: "commuter_package",
  contractorInvoice: "captain_finances/contractor_invoice",
  role: "gandalf/internal/availableRoles",
  endpoints: "end_points",
  rescueReasons: "ride/rescue_reasons",
  rideCategory: "ride_category",
  googleSignInUrl: "google_sign_in",
  captainApp: "captain_app",
  paymentMethod: "payment_method",
  paymentCycleConfigurations: "captain_finances/payment_cycle_configurations",
  fineReimbursement: "fine_reimbursement",
  biddingCampaigns: "bidding_campaigns",
  boardingCheckin: "boarding_configurations",
};

const concatUrl = (url) => baseUrl + url + backslash;
const apis = mapValues(concatUrl)(endpoints);

export default apis;



// WEBPACK FOOTER //
// ./src/core/apis.js